export default {
  dashboard: (state) => {
    return state.dashboard;
  },

  feedbacks: (state) => {
    return state.feedbacks;
  },

  feedbackDetails: (state) => {
    if (
      !state.feedbackDetails ||
      !Array.isArray(state.feedbackDetails.feedbackQuestions)
    ) {
      return null;
    }
    return {
      ...state.feedbackDetails,
      feedbackQuestions: state.feedbackDetails.feedbackQuestions.filter(
        (question) => {
          return (
            (question.feedbackQuestionAnswers &&
              question.feedbackQuestionAnswers.length > 0) ||
            question.answerTypeId === 2
          );
        }
      ),
    };
  },

  campaigns: (state) => {
    return state.campaigns;
  },
  campaignDetail: (state) => {
    return state.campaignDetail;
  },

  activeFeedback: (state) => {
    return state.activeFeedback;
  },

  creditTransaction: (state) => {
    return state.creditTransaction;
  },

  customerScore: (state) => {
    return state.customerScore;
  },

  scoreByCredit: (state) => {
    return state.scoreByCredit;
  },
  getScoreData: (state) => {
    return state.getScoreData;
  },

  privateDiscounts: (state) => {
    return state.privateDiscounts;
  },

  publicDiscounts: (state) => {
    return state.publicDiscounts;
  },

  scoreList: (state) => {
    return state.scoreList;
  },

  receivedScores: (state) => {
    return state.receivedScores;
  },

  scoreDetails: (state) => {
    return state.scoreDetails;
  },

  scoreHistory: (state) => {
    return state.scoreHistory;
  },

  transactions: (state) => {
    return state.transactions;
  },

  transaction: (state) => {
    return state.transaction;
  },
};
